import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "title": _vm.t('免责声明'),
      "width": 900,
      "destroyOnClose": true
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticClass: "notice"
  }, [_vm._v(" " + _vm._s(_vm.t('本公司/本人声明和确认，本公司/本人在此创建和填写的向贵公司支付交易款项的第三方平台付款账户信息真实、准确、有效，该等账户属于本公司/本人所有，本公司/本人所创建和填写的账户名称为本公司/本人在所对应的第三方平台的实名认证主体。')) + " ")]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "type": "primary",
      "fbu-analyse-name": $t("\u786E\u5B9A")
    },
    on: {
      "click": _vm.handle
    }
  }, [_vm._v(_vm._s(_vm.t('确定')))])], 1)]);
};

var staticRenderFns = [];
export { render, staticRenderFns };